import React from 'react'
import classnames from 'classnames'
import { Row, Col } from 'react-flexbox-grid'
import { localize } from '../../util/Localizer'
import Columns from '../../styles/columns'
import CardStyles from '../../styles/cards'
import TitledLabel from '../../controls/TitledLabel'
import PaidByOtherTextField from '../../widgets/SubmitAClaim/PaidByOtherTextField'
import Checkbox from '@material-ui/core/Checkbox'
import Card from '@material-ui/core/Card'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { withStyles } from '@material-ui/core/styles'

class HCSAExpenseLine extends React.Component {
  constructor (props) {
    super(props)
    this.updateValues = this.updateValues.bind(this)
    this.onCheck = this.onCheck.bind(this)
    this.validate = this.validate.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.state = {
      CoordinationOfBenefitsAmount: 0,
      validationError: undefined
    }
  }

  componentDidMount () {
    if (this.props.cob && this.props.cob.CoordinationOfBenefitsAmount) {
      this.setState({
        CoordinationOfBenefitsAmount: this.props.cob.CoordinationOfBenefitsAmount
      })
    }
  }

  shouldComponentUpdate (nextProps, nextState) {
    // here we just check to see if we should update the line item to help improve performance. Problem is HCSAExpenses updates all row items and since
    // we do it on changed of COB number value, it tries to update everything
    var nextExpDetails = JSON.stringify(nextProps.expenseDetail)
    var currExpDetails = JSON.stringify(this.props.expenseDetail)
    const ret = (nextExpDetails !== currExpDetails) ||
      nextProps.isExpenseSelected !== this.props.isExpenseSelected ||
      nextProps.disabled !== this.props.disabled ||
      this.state.CoordinationOfBenefitsAmount !== nextState.CoordinationOfBenefitsAmount ||
      this.state.validationError !== nextState.validationError
    return ret
  }

  updateValues (valueObj) {
    const value = Number(valueObj.CoordinationOfBenefitsAmount)
    this.setState({ CoordinationOfBenefitsAmount: value }, this.validate(value))
  }

  onCheck (e) {
    e.persist() // Necessary to keep the synthetic event from being released

    if (this.cob) {
      this.cob.resetState()
    }

    const { expenseDetail = {} } = this.props
    const value = this.state.CoordinationOfBenefitsAmount

    if (e.target.checked) {
      this.validate(value, true, () => {
        expenseDetail.CoordinationOfBenefitsAmount = value
        this.props.onClick(e, expenseDetail, value)
      }, () => {
        // Set the COB amount to zero if the value is invalid to
        // prevent it from influencing the COB total calculation in
        // the parent component.
        expenseDetail.CoordinationOfBenefitsAmount = 0
        this.props.onClick(e, expenseDetail, 0)
      })
    } else {
      this.setState({ validationError: undefined })
      // Set the COB amount to zero if the value is invalid to
      // prevent it from influencing the COB total calculation in
      // the parent component.
      expenseDetail.CoordinationOfBenefitsAmount = 0
      this.props.onClick(e, expenseDetail, 0)
    }
  }

  onBlur (value) {
    const { expenseDetail = {} } = this.props

    this.validate(value, true, () => {
      this.setState({ CoordinationOfBenefitsAmount: value })
      expenseDetail.CoordinationOfBenefitsAmount = value
      this.props.onBlur(expenseDetail)
    }, () => {
      // Reset the COB amount if the value is empty.
      const updateValue = (value === '') ? 0 : value
      this.setState({ CoordinationOfBenefitsAmount: updateValue })
      // Set the COB amount to zero if the value is invalid to
      // prevent it from influencing the COB total calculation in
      // the parent component.
      expenseDetail.CoordinationOfBenefitsAmount = 0
      this.props.onBlur(expenseDetail)
    })
  }

  validate (value, isExpenseSelected, callback, errorCallback) {
    const num = Number(value)
    if (value !== '' && !isNaN(num)) {
      let isValid = true

      if (this.props.hasCOB) {
        if (num >= this.props.expenseDetail.unpaidAmount) {
          // validation failed so update UI
          this.setState({ validationError: localize('pages.SubmitAClaim.Expenses.cobValidation') })
          isValid = false
        }
      }

      this.props.expenseDetail.isValid = isValid

      if (isValid) {
        // validation is OK so call parent
        this.setState({ validationError: undefined }, callback)
      } else {
        if (errorCallback) {
          errorCallback()
        }
      }
    } else {
      this.setState({ validationError: localize('pages.SubmitAClaim.Expenses.noCobError') })
      this.props.expenseDetail.isValid = false

      if (errorCallback) {
        errorCallback()
      }
    }
  }

  render () {
    const { expenseDetail, hasCOB, classes = {} } = { ...this.props }
    const columns = hasCOB ? Columns.max4 : Columns.max12

    return (
      <Card className={classnames(classes.summaryCard, classes.baseCard)}>
        <Row>
          <Col {...columns}>
            <TitledLabel title='pages.SubmitAClaim.UnpaidExpenses.Claim' format='text' value={expenseDetail.claimCode} />
          </Col>
          <Col {...columns}>
            <TitledLabel title='pages.SubmitAClaim.UnpaidExpenses.ClaimLine' format='text' value={expenseDetail.claimLineId} />
          </Col>
          <Col {...columns}>
            <TitledLabel title='pages.SubmitAClaim.UnpaidExpenses.patientName' format='text' value={expenseDetail.patientName} />
          </Col>
          <Col {...columns}>
            <TitledLabel title='pages.SubmitAClaim.UnpaidExpenses.ServiceDate' format='date' value={expenseDetail.serviceDate} />
          </Col>
          <Col {...columns}>
            <TitledLabel title='pages.SubmitAClaim.UnpaidExpenses.ClaimType' format='text' value={expenseDetail.claimType} />
          </Col>
          <Col {...columns}>
            <TitledLabel title='pages.SubmitAClaim.UnpaidExpenses.UnpaidAmount' format='currency' value={expenseDetail.unpaidAmount} />
          </Col>
          {hasCOB
            ? <Col {...columns}>
              <PaidByOtherTextField
                ref={(comp) => { this.cob = comp }}
                allowEmptyFormatting
                floatinglabelfixed={true}
                textLabel={localize('pages.SubmitAClaim.UnpaidExpenses.AmountPaidByOtherCarrier')}
                className='textBoxPaybyOther'
                maxValue={expenseDetail.unpaidAmount}
                id='CoordinationOfBenefitsAmount'
                autoComplete='off'
                disabled={!this.props.isExpenseSelected}
                onValueChange={this.updateValues}
                value={this.state.CoordinationOfBenefitsAmount}
                onBlur={this.onBlur}
                error={this.state.validationError}
                // margin="normal"
                fullWidth
                styles={{ marginTop: 32 }}
                labelStyles={{ width: '125%', fontSize: '1rem' }}
              />
            </Col>
            : null
          }
          <Col {...columns}>
            <FormControlLabel
              control={
                <Checkbox
                  ref={(check) => { this.check = check }}
                  checked={this.props.isExpenseSelected || false}
                  onChange={(e) => this.onCheck(e)}
                  disabled={(this.props.isExpenseSelected === true) ? false : this.props.disabled}
                  value={'true'}
                  color='primary'
                />
              }
              label={localize('pages.SubmitAClaim.UnpaidExpenses.PayFromHealthCareSpendingAccount')}
            />
          </Col>
        </Row>
      </Card>
    )
  }
}

const styles = {
  ...CardStyles
}

export default withStyles(styles)(HCSAExpenseLine)



// WEBPACK FOOTER //
// ./src/widgets/SubmitAClaim/HCSAExpenseLine.js